import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseUserStatModel from "../../models/case-user-stat";
import qs from "query-string";
export default class CaseUserStatRepository extends BaseRepository {
  static modelClass = CaseUserStatModel;
  modelName = "case-user-stat";

  async findRecord(params) {
    let onlyUserStatParams = {};
    for (let key in params) {
      if (
        key === "overall_status" ||
        key === "overall_status__in" ||
        key === "status" ||
        key === "status_in"
      ) {
        onlyUserStatParams[key] = params[key];
      }
    }

    return await super.findRecord(1, {
      urlPath:
        CaseUserStatModel.urlPath + "?" + qs.stringify(onlyUserStatParams),
    });
  }
}